import { useParams } from "react-router-dom";
import { InnerPage } from "@/components/InnerPage";
import NotFound from "@/pages/NotFound";
import { SERVICES } from "@/data/services";
import { INDUSTRIES } from "@/data/industries";
import { SOLUTIONS } from "@/data/solutions";
import { WORK } from "@/data/work";

// One generic renderer used for every service / industry / solution / case
// study, plus a static wrapper for the AI Lab.

function makeBreadcrumbs(category, node) {
  const parent = { services: "Services", industries: "Industries", solutions: "Solutions", work: "Work" }[category];
  const parentTo = { services: "/services", industries: "/industries", solutions: "/solutions", work: "/work" }[category];
  return [
    { label: "Home", to: "/" },
    { label: parent, to: parentTo },
    { label: node.navLabel || node.h1 },
  ];
}

function DynamicPage({ collection, category, ...rest }) {
  const { slug } = useParams();
  const node = collection[slug];
  if (!node) return <NotFound />;
  return (
    <InnerPage
      {...node}
      {...rest}
      breadcrumbs={makeBreadcrumbs(category, node)}
    />
  );
}

export function ServicePage() {
  return <DynamicPage collection={SERVICES} category="services" serviceWhatsApp />;
}
export function IndustryPage() {
  return <DynamicPage collection={INDUSTRIES} category="industries" />;
}
export function SolutionPage() {
  return <DynamicPage collection={SOLUTIONS} category="solutions" />;
}
export function CaseStudyPage() {
  return <DynamicPage collection={WORK} category="work" />;
}

// AI Lab is /ai-lab, not /services/ai-lab.
export function AiLabPage() {
  const node = SERVICES["ai-lab"];
  return <InnerPage {...node} serviceWhatsApp breadcrumbs={[{ label: "Home", to: "/" }, { label: "AI Lab" }]} />;
}
